import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'
import UserImage from "../../assets/user.png"
import Loader from '../../components/Loader'
import { Link } from 'react-router-dom'

const FriendRequestsReceived = () => {
    const [receivedRequests, setReceivedRequests] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(false)

    useEffect(() => {
        const getReceivedRequests = async () => {
            try {
                setIsLoading(true)
                const response = await api.get("/community/friends/requests")
                // console.log(response)
                if (response) {
                    setIsLoading(false)
                    setReceivedRequests(response?.data)
                }
                else {
                    toast.error("Error getting  friend requests")
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response?.data.message)
            }
        }
        getReceivedRequests()
    }, [])

    const handleRefresh = () => { }

    const acceptFriend = async (id) => {

        const formData = new FormData()
        formData.append("friend", id)
        try {
            const response = await api.patch("/community/friends/requests", formData);
            if (response.status === 200) {
                toast.success("Friend added");
                setReceivedRequests((receivedRequests) =>
                    receivedRequests.filter((friend) => friend._id !== id)
                );
            }
        } catch (error) {
            console.error("Error adding friend:", error);
            toast.error("Failed to add friend");
        }

    }
    const rejectFriend = async (id) => {

        const formData = new FormData()
        formData.append("friend", id)
        try {
            const response = await api.delete("/community/friend/requests", formData);
            if (response.status === 200) {
                toast.success("Friend request removed");
                setReceivedRequests((receivedRequests) =>
                    receivedRequests.filter((friend) => friend._id !== id)
                );
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to remove friend");
        }

    }
    return (
        <div className='users-page-container'>
            <h2 className="users-list-header">Received Friend Requests</h2>
            <InfiniteScroll
                dataLength={receivedRequests.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                Loader={<Loader />}
                pullDownToRefresh={true}
            >
                <div className="users-container">
                    {isLoading && <Loader />}
                    {!isLoading && receivedRequests.length === 0 &&
                        <p className="not-found-msg">No friend requests found</p>
                    }
                    {
                        receivedRequests && receivedRequests.map((frd) => (
                            <div className='user-action-card' key={frd._id}>
                                <Link to={`/user/${frd._id}`}>
                                    <div className="user-action-card-details">
                                        <img src={frd.profilePics?.current ? frd.profilePics.current : UserImage} alt="" />
                                        <div className="action-card-buttons">
                                            <p className="user-names">{frd.firstname} {frd.lastname}</p>
                                            <div className="card-btns">
                                                <button onClick={() => acceptFriend(frd._id)}>Accept</button>
                                                <button onClick={() => rejectFriend(frd._id)}>Reject</button>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))
                    }
                </div>
            </InfiniteScroll>
        </div>
    )
}

export default FriendRequestsReceived